import { ModuleExtensions } from '@wix/premium-fed-sdk/@premium-module';
import { loadPackagePickerTranslations } from './loadTranslations';
export const packagePickerTranslationsExtension = ModuleExtensions.translationsExtension(locale => loadPackagePickerTranslations(locale), {
  namespace: 'premium-purchase-plan-translations'
});
//# sourceMappingURL=package-picker-translations.extension.js.map